/* ===== AquaBulle — global.js ===== */
(function () {
  'use strict';

  /* ---------- Mobile menu ---------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-menu-toggle]');
    if (toggle) {
      var nav = document.querySelector('[data-menu]');
      if (nav) nav.classList.toggle('is-open');
    }
  });

  /* ---------- Cart drawer ---------- */
  var drawer = document.querySelector('[data-cart-drawer]');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-toggle]')) { e.preventDefault(); openDrawer(); }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeDrawer(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  function formatMoney(cents) {
    var format = window.moneyFormat || '€{{amount_with_comma_separator}}';
    var value = (cents / 100).toFixed(2);
    if (format.indexOf('amount_with_comma_separator') !== -1) {
      value = value.replace('.', ',');
    }
    return format.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, value);
  }

  function refreshCart() {
    return fetch(window.routes.cart_url + '.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCartItems(cart);
        var count = document.querySelector('[data-cart-count]');
        if (count) {
          count.textContent = cart.item_count;
          count.classList.toggle('is-hidden', cart.item_count === 0);
        }
        var total = document.querySelector('[data-cart-total]');
        if (total) total.textContent = formatMoney(cart.total_price);
        return cart;
      });
  }

  function renderCartItems(cart) {
    var body = document.querySelector('[data-cart-items]');
    if (!body) return;
    if (cart.item_count === 0) {
      body.innerHTML = '<p class="cart-drawer__empty">' + (body.dataset.emptyText || 'Votre panier est vide') + '</p>';
      return;
    }
    var html = '';
    cart.items.forEach(function (item, i) {
      var variantLine = item.variant_title ? '<p class="cart-item__variant">' + item.variant_title + '</p>' : '';
      var img = item.image ? item.image.replace(/(\.[a-z]{3,4})(\?|$)/, '_160x$1$2') : '';
      html += '<div class="cart-item" data-line="' + (i + 1) + '">' +
        (img ? '<img src="' + img + '" alt="" width="72" height="72" loading="lazy">' : '') +
        '<div class="cart-item__info">' +
          '<p class="cart-item__title">' + item.product_title + '</p>' + variantLine +
          '<div class="cart-item__qty">' +
            '<button data-qty-change="-1" aria-label="-">−</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button data-qty-change="1" aria-label="+">+</button>' +
          '</div>' +
        '</div>' +
        '<div class="cart-item__right">' +
          '<span class="cart-item__price">' + formatMoney(item.final_line_price) + '</span>' +
          '<button class="cart-item__remove" data-qty-change="0">Retirer</button>' +
        '</div>' +
      '</div>';
    });
    body.innerHTML = html;
  }

  /* quantity change / remove in drawer */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var itemEl = btn.closest('[data-line]');
    if (!itemEl) return;
    var line = parseInt(itemEl.dataset.line, 10);
    var delta = parseInt(btn.dataset.qtyChange, 10);
    var qtyEl = itemEl.querySelector('.cart-item__qty span');
    var current = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
    var next = delta === 0 ? 0 : Math.max(0, current + delta);

    fetch(window.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: next })
    }).then(refreshCart);
  });

  /* ---------- Product forms (AJAX add to cart + variant picker) ---------- */
  function initProductForm(root) {
    var form = root.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    var variantsScript = root.querySelector('[data-variants-json]');
    var variants = variantsScript ? JSON.parse(variantsScript.textContent) : null;
    var variantInput = form.querySelector('[data-variant-id]');
    var addBtn = form.querySelector('[data-add-to-cart]');
    var addBtnText = form.querySelector('[data-add-to-cart-text]');

    function selectedOptions() {
      var opts = [];
      root.querySelectorAll('.variant-picker').forEach(function (fs, i) {
        var checked = fs.querySelector('input:checked');
        opts[i] = checked ? checked.value : null;
      });
      return opts;
    }

    function matchVariant() {
      if (!variants) return null;
      var opts = selectedOptions();
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      }) || null;
    }

    root.addEventListener('change', function (e) {
      if (!e.target.classList.contains('variant-picker__input')) return;
      var fs = e.target.closest('.variant-picker');
      var label = fs && fs.querySelector('[data-selected-value]');
      if (label) label.textContent = e.target.value;

      var variant = matchVariant();
      if (variant) {
        variantInput.value = variant.id;
        if (addBtn) addBtn.disabled = !variant.available;
        if (addBtnText) addBtnText.textContent = variant.available ? window.themeStrings.addToCart : window.themeStrings.soldOut;

        var scope = root.closest('section') || document;
        var priceEl = scope.querySelector('[data-price]');
        var compareEl = scope.querySelector('[data-compare-price]');
        var badgeEl = scope.querySelector('[data-discount-badge]');
        if (priceEl) priceEl.textContent = formatMoney(variant.price);
        if (compareEl && badgeEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compareEl.textContent = formatMoney(variant.compare_at_price);
            compareEl.classList.remove('is-hidden');
            var pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
            badgeEl.textContent = '−' + pct + ' %';
            badgeEl.classList.remove('is-hidden');
          } else {
            compareEl.classList.add('is-hidden');
            badgeEl.classList.add('is-hidden');
          }
        }
        var featured = scope.querySelector('[data-featured-image]');
        if (featured && variant.featured_image && variant.featured_image.src) {
          featured.src = variant.featured_image.src;
        }
      } else {
        if (addBtn) addBtn.disabled = true;
        if (addBtnText) addBtnText.textContent = window.themeStrings.unavailable;
      }
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (addBtn) addBtn.disabled = true;
      fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: parseInt(variantInput.value, 10),
          quantity: parseInt((form.querySelector('[name="quantity"]') || { value: 1 }).value, 10)
        })
      })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () { return refreshCart(); })
      .then(function () {
        openDrawer();
        if (addBtn) addBtn.disabled = false;
      })
      .catch(function () {
        if (addBtn) addBtn.disabled = false;
        window.location.href = window.routes.cart_url;
      });
    });
  }

  document.querySelectorAll('product-form').forEach(initProductForm);

  /* re-init inside Shopify theme editor when sections reload */
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('product-form').forEach(initProductForm);
  });

  /* ---------- Product gallery thumbs ---------- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('.main-product__gallery');
    var featured = gallery && gallery.querySelector('[data-featured-image]');
    if (featured) featured.src = thumb.dataset.src;
  });
})();
